import * as React from 'react'
import { Button } from '@pareto-engineering/design-system'
import PropTypes from 'prop-types'
import { useConversionForm } from 'modules/components'

const localStoragePlanKey = 'selectedPlan'

const ConversionFormButton = ({
  id,
  children,
  plan,
  ...otherProps
}) => {
  const { setIsOpen } = useConversionForm()
  const isClient = typeof window === 'object'

  const handleClick = () => {
    if (isClient) localStorage.setItem(localStoragePlanKey, JSON.stringify(plan))
    setIsOpen(true)
  }
  return (
    <Button {...otherProps} onClick={() => handleClick()}>
      {children}
    </Button>
  )
}

ConversionFormButton.propTypes = {
  /**
   * The ID of the component
   */
  id:PropTypes.string,

  /**
   * The className of the component
   */
  className:PropTypes.string,

  /**
   * The style of the component
   */
  style:PropTypes.objectOf({}),

  /**
   * The child nodes of the component
   */
  children:PropTypes.node,

  /**
   * If this button is associated with a plan
   */
  plan:PropTypes.bool,
}

ConversionFormButton.defaultProps = {
  //
}

export default ConversionFormButton
